export const COLORS = {
  // Primary Colors
  PRIMARY: '#1976d2',
  PRIMARY_LIGHT: '#42a5f5',
  PRIMARY_DARK: '#1565c0',
  PRIMARY_BLUE: '#0072C6',
  PRIMARY_BLUE_DARK: '#27467a',

  // Secondary Colors
  SECONDARY: '#dc004e',
  SECONDARY_LIGHT: '#ff5983',
  SECONDARY_DARK: '#9a0036',
  SECONDARY_RED: '#e65100',

  // Success Colors
  SUCCESS: '#4caf50',
  SUCCESS_LIGHT: '#e8f5e9',
  SUCCESS_DARK: '#2e7d32',
  SUCCESS_GREEN: '#28a745',

  // Error Colors
  ERROR: '#f44336',
  ERROR_LIGHT: '#ffebee',
  ERROR_DARK: '#d32f2f',
  ERROR_RED: '#e74c3c',

  // Warning Colors
  WARNING: '#ff9800',
  WARNING_LIGHT: '#fff3e0',
  WARNING_DARK: '#ed6c02',
  WARNING_YELLOW: '#ffc107',

  // Info Colors
  INFO: '#2196f3',
  INFO_LIGHT: '#e3f2fd',

  // Text Colors
  TEXT_WHITE: '#ffffff',
  TEXT_BLACK: '#000000',

  // Background Colors
  BACKGROUND_PAPER: '#ffffff',
  BACKGROUND_LIGHT: '#f8f9fa',
  BACKGROUND_WARNING: '#fff3cd',

  // Gray Colors
  GRAY_50: '#fafafa',
  GRAY_100: '#f5f5f5',
  GRAY_200: '#e0e0e0',
  GRAY_300: '#cccccc',
  GRAY_400: '#9e9e9e',
  GRAY_500: '#757575',
  GRAY_600: '#666666',
  GRAY_700: '#424242',
  GRAY_800: '#333333',
  GRAY_900: '#212121',

  // Border Colors
  BORDER_LIGHT: '#e9ecef',
  BORDER_MEDIUM: '#ced4da',
  BORDER_DARK: '#666666',

  // Button Colors
  BUTTON_SUCCESS: '#28a745',
  BUTTON_SUCCESS_HOVER: '#218838',
  BUTTON_SUCCESS_BORDER: '#1e7e34',

  // Upload Colors
  UPLOAD_BACKGROUND: '#fafafa',

  // Bulk Action Colors
  BULK_ACTION_BG: '#fff3cd',
  BULK_ACTION_BORDER: '#ffeaa7',

  // CSS Root Variables
  LIGHT_GREEN: '#d4edda',
  STATUS_GRAY: '#6c757d',
  WHITE: '#ffffff',
  LIGHT_GRAY: '#f8f9fa',
  DARK_GRAY: '#343a40',
  BLACK: '#000000',
} as const;

export default COLORS;
